import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *  ui: import('./ui').MediaLibraryUIReducer,
 *  data: import('./data').MediaLibraryDataReducer,
 *  filters: import('./ui/filters').MediaLibraryFiltersReducer,
 *  }} MediaLibraryReducer
 */
export default combineReducers({
  data,
  ui,
});
